import { botaoIconeSvg } from './BotaoIconeSvg.styles'

export const botaoIconeSvgIO = () => {
  return {
    styles: botaoIconeSvg
  }
}

export type BotaoIconeSvgIO = ReturnType<typeof botaoIconeSvgIO>
